module.exports = __webpack_public_path__ + "5f1c66ea5d65bb95c4d49eebcbf9a3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/help/help-center-en.png
// module id = 463
// module chunks = 0